export const POD_MAX_FILES = 2
export const POD_MAX_TOTAL_BYTES = 5 * 1024 * 1024

const ALLOWED_EXTENSIONS_BY_MIME = {
  'image/jpeg': ['jpg', 'jpeg'],
  'image/png': ['png'],
  'application/pdf': ['pdf'],
}

function extensionOf(fileName) {
  return String(fileName || '').split('.').pop()?.toLowerCase() || ''
}

export function isAllowedProofFile(file) {
  const mime = String(file?.type || file?.mimetype || '').toLowerCase()
  const allowed = ALLOWED_EXTENSIONS_BY_MIME[mime]
  if (!allowed) return false
  return allowed.includes(extensionOf(file?.name || file?.originalname))
}

/**
 * @returns {string|null} Validation message, or null when the selection is allowed.
 */
export function validateProofOfDeliverySelection(existingFiles, incomingFiles) {
  const existing = existingFiles || []
  const incoming = incomingFiles || []
  if (!incoming.length) return 'Select at least one file.'
  if (existing.length + incoming.length > POD_MAX_FILES) {
    return 'Maximum 2 proof of delivery files per shipment.'
  }
  for (const file of incoming) {
    const name = file?.name || 'upload'
    if (!isAllowedProofFile(file)) {
      return `${name} must be a JPG, JPEG, PNG, or PDF.`
    }
    if (file.size > POD_MAX_TOTAL_BYTES) {
      return `${name} exceeds the 5 MB shipment limit.`
    }
  }
  const existingBytes = existing.reduce((sum, file) => sum + (Number(file.size_bytes) || 0), 0)
  const incomingBytes = incoming.reduce((sum, file) => sum + (Number(file.size) || 0), 0)
  if (existingBytes + incomingBytes > POD_MAX_TOTAL_BYTES) {
    return 'Combined proof of delivery files must be 5 MB or smaller per shipment.'
  }
  return null
}

export function formatProofFileSize(bytes) {
  const n = Number(bytes) || 0
  if (n >= 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(2)} MB`
  if (n >= 1024) return `${Math.round(n / 1024)} KB`
  return `${n} B`
}

export function proofFileTypeLabel(file) {
  const mime = String(file?.mime_type || '').toLowerCase()
  if (mime === 'application/pdf') return 'PDF'
  if (mime === 'image/png') return 'PNG'
  if (mime === 'image/jpeg') return 'JPEG'
  const ext = extensionOf(file?.file_name).toUpperCase()
  return ext || 'File'
}
